import React from "react";
import NavBar from "../gui/NavBar";
import { Container, Row, Col, Alert } from "react-bootstrap";
var qs = require("query-string");

export default class Canvas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      filename: "",
      folder: "",
      msg: "",
      annotations: {},
    };
    this.query = qs.parse(this.props.location.search, { parameterLimit: 1 });
  }

  async componentDidMount() {
    var hash = this.query.file;
    await fetch(`https://bimapi.velociti.cl/unhash/${hash}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "public_auth",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          var filename = result[0].file_name.replace(/\.ifc$/, "");
          var folder = result[0].folder;
          var loading = result[0].loading.data[0] === 1;
          this.setState({
            filename: filename,
            folder: folder,
            msg: loading
              ? "El modelo aún está siendo procesado, intente nuevamente más tarde."
              : "",
          });
        },
        (error) => this.setState({ msg: "Error cargando el modelo [1]" })
      );

    fetch(`https://bimapi.velociti.cl/annotations`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "public_auth",
      },
      body: JSON.stringify({
        filename: this.state.filename,
        folder: this.state.folder,
        mode: "READ",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status === 200) {
            this.setState({ annotations: result.annotations, loading: false });
          } else if (result.status === 500 && result.err.code === "ENOENT") {
            this.setState({ loading: false });
          } else {
            this.setState({ msg: "Error cargando el modelo [2]" });
          }
        },
        (error) => this.setState({ msg: "Error cargando el modelo [3]" })
      );
  }

  build() {
    var { filename, folder, annotations } = this.state;

    window.camera = null;
    window.input = null;
    window.xhttp = null;
    window.xmlDoc = null; // XML with IFC metadata
    window.model = { loaded: false };
    window.mcenter = { x: 0, y: 0, z: 0 }; // Model center
    window.mmin = { x: 0, t: 0, z: 0 }; // Model aabb min coords
    window.mmax = { x: 0, t: 0, z: 0 }; // Model aabb max coords

    // Create scenes
    window.scene = new window.xeogl.Scene({
      canvas: "canvas",
      transparent: true,
    });
    window.vc_scene = new window.xeogl.Scene({
      canvas: "view-cube-canvas",
      transparent: true,
    });

    // Create view cube
    window.vc_center = window.createBaseCube(
      window.vc_scene,
      "./textures/blank.jpg"
    );

    // Set camera flights
    window.cameraFlight = new window.xeogl.CameraFlightAnimation(window.scene);
    window.vcCameraFlight = new window.xeogl.CameraFlightAnimation(
      window.vc_scene
    );

    // Set camera controls
    window.vcCameraControl = new window.xeogl.CameraControl(window.vc_scene, {
      doublePickFlyTo: false,
      meta: {
        disableOrbit: true,
        pan: true,
        zoom: false,
      },
    });
    window.cameraControl = new window.xeogl.CameraControl(window.scene, {
      meta: {
        scene2: window.vc_scene,
      },
    });
    window.cameraControlPan = new window.xeogl.CameraControl(window.scene, {
      active: false,
      meta: {
        pan: true,
        zoom: false,
      },
    });
    window.cameraControlZoom = new window.xeogl.CameraControl(window.scene, {
      active: false,
      meta: {
        pan: false,
        zoom: true,
      },
    });

    window.xeogl.setDefaultScene(window.scene);

    window.model = new window.xeogl.GLTFModel({
      id: "model",
      src: `../models/${folder}/${filename}.gltf`,
      handleNode: function(nodeInfo, actions) {
        if (nodeInfo.name && nodeInfo.mesh !== undefined) {
          actions.createObject = {
            id: nodeInfo.name,
          };
        }
        return true;
      },
    });

    window.model.on("loaded", function() {
      window.model.loaded = true;
      window.mcenter.x = window.model.center[0];
      window.mcenter.y = window.model.center[1];
      window.mcenter.z = window.model.center[2];
      window.mmin.x = window.model.aabb[0];
      window.mmin.y = window.model.aabb[1];
      window.mmin.z = window.model.aabb[5];
      window.mmax.x = window.model.aabb[3];
      window.mmax.y = window.model.aabb[4];
      window.mmax.z = window.model.aabb[2];
      window.camera = window.scene.camera;
      window.input = window.scene.input;

      // Camera starting position
      window.camera.eye = [window.mcenter.x, window.mcenter.y, window.mmin.z];
      window.camera.look = [
        window.mcenter.x,
        window.mcenter.y,
        window.mcenter.z,
      ];
      window.camera.up = [0, 1, 0];

      // Y axis up
      window.camera.worldAxis = [
        1, 0, 0, // Right
        0, 1, 0, // Up
        0, 0, -1, // Forward
      ];

      // Load IFC metadata
      window.xhttp = new XMLHttpRequest();
      window.xhttp.open(
        "GET",
        `../models/${folder}/${filename}_id.json`,
        false
      );
      window.xhttp.send();
      window.xmlDoc = JSON.parse(window.xhttp.response);

      // Set orbit mouse on
      window.orbitCameraFun();

      window.cameraFlight.flyTo(window.model.aabb, function() {
        let eye = window.camera.eye;
        var radius = Math.max(
          Math.abs(eye[0] - window.mcenter.x),
          Math.abs(eye[1] - window.mcenter.y),
          Math.abs(eye[2] - window.mcenter.z)
        );
        window.createViewCube(window.vc_scene, {
          blank: "./textures/blank.jpg",
          top: "./textures/top.jpg",
          bottom: "./textures/bottom.jpg",
          left: "./textures/left.jpg",
          right: "./textures/right.jpg",
          front: "./textures/front.jpg",
          back: "./textures/back.jpg",
        });
        window.vcCameraFlight.flyTo(window.vc_center, function() {
          var vcRadius = window.vc_scene.camera.eye[2];
          window.configureVC(
            window.vcCameraControl,
            window.vcCameraFlight,
            window.cameraFlight,
            radius,
            vcRadius
          );
        });
      });

      // Configure View Cube
      window.vc_scene.camera.projection = "ortho";
      window.vc_scene.camera.ortho.scale = 4.6;

      // Load annotations
      window.loadAnnotations(annotations);

      // Configure loading spinner
      document.getElementById("container--box").style.opacity = "0";
      setTimeout(function() {
        document.getElementById("container--box").style.visibility = "hidden";
      }, 200);
    });

    window.model.on("error", function() {
      window.model.loaded = false;
    });

    // Configure dat.GUI
    var guiWidth = Math.min(500, window.innerWidth);
    window.gui = new window.dat.GUI({
      width: guiWidth,
      resizable: false,
    });
    window.gui.domElement.id = "gui";
    document
      .getElementById("dat-gui-container")
      .appendChild(window.gui.domElement);
    document.getElementById("gui").style.zIndex = "1";
  }

  render() {
    var { filename, folder, msg, loading } = this.state;
    if (msg !== "") {
      document.getElementById("container--box").style.visibility = "hidden";
      return (
        <Container fluid style={{ maxWidth: "100vw", width: "100vw" }}>
          <Row className="justify-content-center mt-3">
            <Col xs="auto">
              <Alert variant="danger" className="text-center">
                <strong>{msg}</strong>
              </Alert>
            </Col>
          </Row>
        </Container>
      );
    } else {
      if (loading) {
        document.getElementById("container--box").style.visibility = "visible";
        return null;
      } else {
        document.getElementById("container--box").style.visibility = "visible";
        this.build();
        return <NavBar filename={filename} folder={folder} />;
      }
    }
  }
}
